import { useMutation } from "@tanstack/react-query";
import { activateTrial, loginUser } from "../UpsellPanelService";

export const useLoginMutation = () => {
    return useMutation({
        mutationFn: async (model) => await loginUser(model)
    });
}
export const useActivateTrialMutation = () => {
    return useMutation({
        mutationFn: async (model) => await activateTrial(model)
    });
}